module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/philosophy01_sp-da886b1d790e80b731f8325fbbab278a.png";